import { ApplicationState } from 'redux/reducers/index';

export const caseStatusStateSelector = (state: ApplicationState) =>
  state.caseStatus;

export const serviceStatusStateSelector = (state: ApplicationState) =>
  caseStatusStateSelector(state).services;

export const otherServicesStatusSelector = (state: ApplicationState) =>
  serviceStatusStateSelector(state).data.filter(
    d => d.service_code !== 'TOWING',
  );

export const caseReferenceSelector = (state: ApplicationState) =>
  caseStatusStateSelector(state)?.caseReference ||
  state.caseCreation.response.caseReference ||
  '';

export const serviceStatusForTowingSelector = (state: ApplicationState) =>
  serviceStatusStateSelector(state).data.filter(
    d => d.service_code === 'TOWING',
  )[0];
